// import './assets/css/theme.css';
import './assets/css/fonts.css';
import './locales/i18n';

import React from 'react';
import ReactDOM from 'react-dom/client';

import AppContainer from './AppContainer';
import 'bootstrap/dist/css/bootstrap.min.css'


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AppContainer />
  </React.StrictMode>
);
